import { default as locale } from 'date-fns__legacy__/locale/pt'
import differenceInDays from 'date-fns__legacy__/difference_in_days'
import format from 'date-fns__legacy__/format'
import isToday from 'date-fns__legacy__/is_today'
import isYesterday from 'date-fns__legacy__/is_yesterday'

const chatMessageDate = (date) => {
  let dateFormat = format(date, 'HH:mm', { locale })

  if (isToday(date)) {
    dateFormat = `Hoje - ${dateFormat}`
  }
  else if (isYesterday(date)) {
    dateFormat = `Ontem - ${dateFormat}`
  }
  else if (differenceInDays(new Date, date) < 7) {
    const week = format(date, 'dddd', { locale })

    dateFormat = `${week} - ${dateFormat}`
  }
  else {
    const fullDate = format(date, 'DD/MM/YY', { locale })

    dateFormat = `${fullDate} - ${dateFormat}`
  }

  return dateFormat
}

export default chatMessageDate